var _path, _circle, _circle2, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssessmentStepThree = function SvgAssessmentStepThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9AA0AB",
    d: "M0 6.5h135"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 6.5,
    r: 6,
    fill: "#fff",
    stroke: "#248BF2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 6.5,
    r: 3.5,
    fill: "#248BF2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 6.5,
    r: 3.5,
    fill: "#248BF2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 6.5,
    r: 3.5,
    fill: "#9AA0AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#248BF2",
    d: "M47 6.5h35M7 6.5h35"
  })));
};
export { SvgAssessmentStepThree as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='136' height='13' viewBox='0 0 136 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cline x1='-4.37114e-08' y1='6.5' x2='135' y2='6.49999' stroke='%239AA0AB'/%3E %3Ccircle cx='88.5' cy='6.5' r='6' fill='white' stroke='%23248BF2'/%3E %3Ccircle cx='3.5' cy='6.5' r='3.5' fill='%23248BF2'/%3E %3Ccircle cx='44.5' cy='6.5' r='3.5' fill='%23248BF2'/%3E %3Ccircle cx='132.5' cy='6.5' r='3.5' fill='%239AA0AB'/%3E %3Cline x1='47' y1='6.5' x2='82' y2='6.5' stroke='%23248BF2'/%3E %3Cline x1='7' y1='6.5' x2='42' y2='6.5' stroke='%23248BF2'/%3E %3C/svg%3E";